import {
  persistentReducedStream,
  reducer,
  streamReducer,
} from '@ardoq/rxbeach';
import { documentArchiveAttachments$ } from 'streams/documentArchive/documentArchiveAttachments$';
import {
  setAllConnectionsScopeData,
  setBusinessCriticalFieldIds,
  loadComponentOverview,
  setComponentOverviewData,
  setComponentOverviewPageError,
  setComponentOverviewPageUnavailable,
  setReferencesTabScopeData,
  setRelevantSurveys,
} from './actions';
import { componentOverviewPageOperations } from './componentOverviewPageOperations';
import { componentOverviewPageComponentId$ } from './componentOverviewPageLocation$';
import type { ComponentOverviewPageState } from './types';
import {
  fieldValueUpdateSuccess,
  saveTagsSuccess,
  setCurrentTab,
} from 'componentOverview2025/actions';
import { setStateProperty } from '@ardoq/common-helpers';

const defaultState: ComponentOverviewPageState = {
  scopeData: null,
  allConnectionsScopeData: null,
  referencesTabScopeData: null,
  componentId: null,
  relevantSurveys: [],
  relevantSurveysLoaded: false,
  businessCriticalFieldIds: [],
  hasError: false,
  isUnavailable: false,
  currentTab: 'overview',
};

export const componentOverviewPage$ =
  persistentReducedStream<ComponentOverviewPageState>(
    'componentOverviewPage$',
    defaultState,
    [
      reducer(
        setComponentOverviewData,
        componentOverviewPageOperations.setComponentOverviewData
      ),
      reducer(
        setAllConnectionsScopeData,
        componentOverviewPageOperations.setAllConnectionsScopeData
      ),
      reducer(
        setReferencesTabScopeData,
        componentOverviewPageOperations.setReferencesTabScopeData
      ),
      reducer(
        loadComponentOverview,
        componentOverviewPageOperations.setComponentOverviewId
      ),
      reducer(
        setRelevantSurveys,
        componentOverviewPageOperations.setRelevantSurveys
      ),
      reducer(
        setBusinessCriticalFieldIds,
        componentOverviewPageOperations.setBusinessCriticalFieldIds
      ),
      reducer(
        setComponentOverviewPageError,
        componentOverviewPageOperations.setComponentOverviewPageError
      ),
      reducer(
        setComponentOverviewPageUnavailable,
        componentOverviewPageOperations.setComponentOverviewPageUnavailable
      ),
      reducer(
        fieldValueUpdateSuccess,
        componentOverviewPageOperations.fieldValueUpdateSuccess
      ),
      reducer(saveTagsSuccess, componentOverviewPageOperations.saveTagsSuccess),
      reducer(setCurrentTab, setStateProperty('currentTab')),
      streamReducer(
        componentOverviewPageComponentId$,
        componentOverviewPageOperations.setComponentOverviewId
      ),
      streamReducer(
        documentArchiveAttachments$,
        componentOverviewPageOperations.updateAttachments
      ),
    ]
  );
